<template>
	<div class="tag-list-empty-state">
		<div class="tag-list-empty-state__number">
			01
		</div>
		<div class="tag-list-empty-state__content">
			<h3 class="tag-list-empty-state__title">
				{{ $I18n.trans('highlights.highlight_tool.instructions.no_tags') }}
			</h3>
			<p class="tag-list-empty-state__text">
				{{ $I18n.trans(hasHighlightDetection ? 'highlights.highlight_tool.instructions.no_tags_description_iq' : 'highlights.highlight_tool.instructions.no_tags_description_no_iq') }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name:  'TagListEmptyState',
	props: {
		hasHighlightDetection: {
			type:     Boolean,
			required: false,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.tag-list-empty-state {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	padding: 0 $sp4;
	height: 40vh;

	@include size(sm-up) {
		height: 50vh;
	}
}

.tag-list-empty-state__number {
	font-size: 100px;
	font-weight: 600;
	line-height: 1;
	color: var(--color-grey-600);
	margin-bottom: $sp3;
}

.tag-list-empty-state__content {
	display: flex;
	flex-direction: column;
	gap: $sp2;
	max-width: 100%;
	text-align: center;
}

.tag-list-empty-state__title {
	font-size: 18px;
	font-weight: bold;
	margin-bottom: $sp2;
	color: var(--color-white);
}

.tag-list-empty-state__text {
	font-size: 14px;
	color: var(--color-grey-300);
	margin: 0;
	line-height: 1.4;
	text-align: center;
}
</style>
